import React, { useState, useEffect } from "react";
import styled from 'styled-components';

import ScenesGalleryViewer from "./scenes-gallery-viewer.js";
import { fetchPlaylistByIdAPI, fetchAdminPlaylistByIdAPI } from "../../controller/userController.js";
import MultiPlayer from "./multi-player.js";

const PageContainer = styled.div`
    width: 100%;
    padding: 32px 20px;
    background: #fafafa;
    min-height: 100vh;
`;

const ContentWrapper = styled.div`
    max-width: 1400px;
    margin: 0 auto;
`;

const HeaderSection = styled.div`
    margin-bottom: 40px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 16px;
    padding-bottom: 24px;
    border-bottom: 2px solid #f0f0f0;
`;

const Title = styled.h1`
    font-size: 36px;
    font-weight: 700;
    color: #1a1a1a;
    margin: 0;
    background: linear-gradient(135deg, #0f766e 0%, #06b6d4 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
`;

const ScenesSection = styled.section`
    margin-bottom: 40px;
`;

const MultiplayerSection = styled.section`
    background: white;
    border-radius: 12px;
    padding: 24px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
`;

export default function PlaylistView(props) {
    const [playlists, setPlaylists] = useState([]);
    const [scenes, setScenes] = useState([]);

    const fetchPlaylistCallback = (data) => {
        if (data && data.length === 0) {
            // Playlist not owned by current user, try admin endpoint
            fetchAdminPlaylistByIdAPI(props.match.params.id, adminCallback);
            return;
        }
        setPlaylists(data);
        formatScenes(data.scenes);
    };

    const adminCallback = (data) => {
        if (data) {
            setPlaylists(data);
            formatScenes(data.scenes);
        }
    };

    const refresh = () => {
        fetchPlaylistByIdAPI(props.match.params.id, fetchPlaylistCallback);
    };

    useEffect(() => {
        fetchPlaylistByIdAPI(props.match.params.id, fetchPlaylistCallback);
    }, []);

    const formatScenes = (plScenes) => {
        var sclist = [];
        for (var s in plScenes) {
            sclist.push(plScenes[s].scene);
        }
        setScenes(sclist);
    };

    return (
        <PageContainer>
            <ContentWrapper>
                <HeaderSection>
                    <Title>Playlist: {playlists.title}</Title>
                </HeaderSection>

                <ScenesSection>
                    <ScenesGalleryViewer
                        scenes={scenes}
                        refresh={refresh}
                        settings={{
                            menu: {
                                addToFavorite: true,
                                removeFromPlaylist: true,
                            },
                            pid: props.match.params.id,
                        }}
                    />
                </ScenesSection>

                <MultiplayerSection>
                    <MultiPlayer scenes={scenes} />
                </MultiplayerSection>
            </ContentWrapper>
        </PageContainer>
    );
}
